<template>
  <el-dialog
    :model-value="state.warningVisible"
    custom-class="session-timeout-dialog"
    title="You're about to be signed out"
    width="440px"
    top="30vh"
    append-to-body
    :show-close="false"
    :close-on-click-modal="false"
    :before-close="staySignedIn"
  >
    <template #title>
      <h2 class="session-timeout-title">You're about to be signed out</h2>
    </template>
    <div class="session-timeout-body">
      <p>
        For your security, you will be signed out in
        <strong class="session-timeout-countdown">{{ timeLeftText }}</strong>
        because you have not been active.
      </p>
      <p class="session-timeout-note">
        Any changes you have not saved will be lost.
      </p>
    </div>
    <p class="session-timeout-live" aria-live="polite">{{ announcement }}</p>
    <template #footer>
      <div class="session-timeout-actions">
        <el-button class="session-timeout-signout" @click="signOutNow">
          Sign out
        </el-button>
        <el-button
          ref="stayButton"
          type="primary"
          class="session-timeout-stay"
          @click="staySignedIn"
        >
          Stay signed in
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {
  idleSessionState,
  staySignedIn,
  signOutNow,
} from "@/helpers/idleSession";

// Screen readers hear the time left at these points rather than every second.
const ANNOUNCE_AT_SECONDS = [60, 30, 20, 10];

export default {
  name: "SessionTimeoutWarning",
  data() {
    return {
      state: idleSessionState,
      announcement: "",
    };
  },
  computed: {
    timeLeftText() {
      return this.formatTimeLeft(this.state.secondsLeft);
    },
  },
  watch: {
    "state.secondsLeft"(seconds) {
      if (ANNOUNCE_AT_SECONDS.includes(seconds)) {
        this.announcement = `You will be signed out in ${this.formatTimeLeft(
          seconds
        )}.`;
      }
    },
    "state.warningVisible"(visible) {
      if (!visible) {
        this.announcement = "";
        return;
      }
      this.$nextTick(() => {
        const button = this.$refs.stayButton;
        if (button && button.$el) button.$el.focus();
      });
    },
  },
  methods: {
    staySignedIn,
    signOutNow,
    formatTimeLeft(seconds) {
      if (seconds > 60) {
        const minutes = Math.ceil(seconds / 60);
        return `${minutes} minutes`;
      }
      return seconds === 1 ? "1 second" : `${seconds} seconds`;
    },
  },
};
</script>

<style lang="scss">
.session-timeout-dialog {
  border-radius: 10px;

  .el-dialog__header {
    padding: 22px 24px 0;
    margin-right: 0;
  }
  .el-dialog__body {
    padding: 12px 24px 0;
  }
  .el-dialog__footer {
    padding: 20px 24px 22px;
  }
  .session-timeout-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
  }
  .session-timeout-body {
    font-size: 15px;
    line-height: 1.5;
    color: #374151;
    word-break: normal;

    p {
      margin: 0;
    }
    .session-timeout-countdown {
      color: #c0392b;
      font-variant-numeric: tabular-nums;
      white-space: nowrap;
    }
    .session-timeout-note {
      margin-top: 10px;
      font-size: 14px;
      color: #6b7280;
    }
  }
  .session-timeout-live {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
  .session-timeout-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .el-button {
      min-width: 120px;
      height: 38px;
      margin-left: 0;
      font-weight: 500;
    }
    .session-timeout-stay {
      background: #273480;
      border-color: #273480;
    }
  }
}
</style>
